// extracted by mini-css-extract-plugin
export default {"arrow":"_4Zoz0","mobile":"Wvz0K"};